export const ROUTER_HISTORY_CALLED = 'ROUTER_HISTORY_CALLED';
export const ROUTER_DATA_LOAD_PENDING = 'ROUTER_DATA_LOAD_PENDING';
export const ROUTER_DATA_LOAD_FULFILLED = 'ROUTER_DATA_LOAD_FULFILLED';

const updateLocation = method => {
    return (url, ...args) => {
        return {
            type: ROUTER_HISTORY_CALLED,
            payload: {
                method,
                url,
                args,
            },
        };
    };
};

export const push = updateLocation('push');
export const replace = updateLocation('replace');
export const pop = updateLocation('pop');
export const go = updateLocation('go');
export const goBack = updateLocation('goBack');
export const goForward = updateLocation('goForward');

export const dataLoadPending = ({historyAction, location}) => {
    return {
        type: ROUTER_DATA_LOAD_PENDING,
        payload: {
            historyAction,
            location,
        },
    };
};

export const dataLoadFulfilled = cleanedData => {
    return {
        type: ROUTER_DATA_LOAD_FULFILLED,
        payload: cleanedData,
    };
};
